import { useContext } from "react"
import LockingAreaContext from "../context/LockingAreaContext"

const UseLockingAreaContext = () => {
    return useContext(LockingAreaContext);
}

export default UseLockingAreaContext